.button {
  min-width: 6em;
  padding: 7px 10px;
  border: 1px solid var(--button-border);
  background-color: var(--button-background);
  font-size: 11px;
  font-family: "Segoe UI", Segoe, Tahoma, Helvetica, Arial, sans-serif;
  color: var(--button-text);
  outline: none;
}

.button:hover {
  border-color: var(--hover-dark);
  background-color: var(--hover-dark);
  color: #000;
}

.button[disabled] {
  border-color: var(--button-border-disabled);
  background-color: var(--button-background-disabled);
  color: var(--button-text-disabled);
}
